function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "copy-05"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.66675 13.3332V15.6665C6.66675 16.5999 6.66675 17.0666 6.8484 17.4232C7.00819 17.7368 7.26316 17.9917 7.57676 18.1515C7.93328 18.3332 8.39999 18.3332 9.33341 18.3332H15.6667C16.6002 18.3332 17.0669 18.3332 17.4234 18.1515C17.737 17.9917 17.992 17.7368 18.1518 17.4232C18.3334 17.0666 18.3334 16.5999 18.3334 15.6665V9.33317C18.3334 8.39975 18.3334 7.93304 18.1518 7.57652C17.992 7.26292 17.737 7.00795 17.4234 6.84816C17.0669 6.6665 16.6002 6.6665 15.6667 6.6665H13.3334M4.33341 13.3332H10.6667C11.6002 13.3332 12.0669 13.3332 12.4234 13.1515C12.737 12.9917 12.992 12.7368 13.1518 12.4232C13.3334 12.0666 13.3334 11.5999 13.3334 10.6665V4.33317C13.3334 3.39975 13.3334 2.93304 13.1518 2.57652C12.992 2.26292 12.737 2.00795 12.4234 1.84816C12.0669 1.6665 11.6002 1.6665 10.6667 1.6665H4.33341C3.39999 1.6665 2.93328 1.6665 2.57676 1.84816C2.26316 2.00795 2.00819 2.26292 1.8484 2.57652C1.66675 2.93304 1.66675 3.39975 1.66675 4.33317V10.6665C1.66675 11.5999 1.66675 12.0666 1.8484 12.4232C2.00819 12.7368 2.26316 12.9917 2.57676 13.1515C2.93328 13.3332 3.39999 13.3332 4.33341 13.3332Z",
    stroke: "#AB8CEF",
    style: {
      stroke: "#AB8CEF",
      stroke: "color(display-p3 0.6706 0.5490 0.9373)",
      strokeOpacity: 1
    },
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7e6698f36f0138e66cbe0f67f759dc05.svg";
export { ForwardRef as ReactComponent };